<a class="back-link" (click)="onLinkClick()">
  <i class="fa fa-light fa-angle-left" aria-hidden="true"></i>
  {{ linkText | translate }}
</a>
